import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';

const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) => error?.response?.data?.message || error?.message || 'Unable to process holiday request';

const ProjectHolidayReducer = createSlice({
  name: 'projectHoliday',
  initialState: {
    projectHolidayList: { data: [], totalRecords: 0 },
    projectHolidayLoading: false,
    projectHolidaySaving: false,
    projectHolidayError: null,
    projectHolidaySuccessMessage: '',
  },
  reducers: {
    getProjectHolidayRequest(state) {
      state.projectHolidayLoading = true;
      state.projectHolidayError = null;
    },
    getProjectHolidaySuccess(state, action) {
      state.projectHolidayLoading = false;
      state.projectHolidayList = action.payload;
    },
    getProjectHolidayFail(state, action) {
      state.projectHolidayLoading = false;
      state.projectHolidayError = action.payload;
    },
    getProjectHolidayByIdSuccess(state) {
      state.projectHolidayLoading = false;
    },
    saveProjectHolidayRequest(state) {
      state.projectHolidaySaving = true;
      state.projectHolidayError = null;
      state.projectHolidaySuccessMessage = '';
    },
    saveProjectHolidaySuccess(state, action) {
      state.projectHolidaySaving = false;
      state.projectHolidaySuccessMessage = action.payload;
    },
    saveProjectHolidayFail(state, action) {
      state.projectHolidaySaving = false;
      state.projectHolidayError = action.payload;
    },
    clearProjectHolidayMessage(state) {
      state.projectHolidayError = null;
      state.projectHolidaySuccessMessage = '';
    },
  },
});

export const {
  getProjectHolidayRequest,
  getProjectHolidaySuccess,
  getProjectHolidayFail,
  getProjectHolidayByIdSuccess,
  saveProjectHolidayRequest,
  saveProjectHolidaySuccess,
  saveProjectHolidayFail,
  clearProjectHolidayMessage,
} = ProjectHolidayReducer.actions;

export const getProjectHolidayListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getProjectHolidayRequest());
    const { data } = await axiosInstance.get('/ProjectHoliday/GetProjectHolidayList', {
      ...getAxiosConfig(token),
      params: {
        HolidayId: form?.HolidayId ?? form?.holidayId ?? 0,
        ProjectId: form?.ProjectId ?? form?.projectId ?? 0,
      },
    });
    dispatch(getProjectHolidaySuccess(data));
    return data;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch(getProjectHolidayFail(message));
    return { status: 0, message };
  }
};

export const getProjectHolidayByIdDispatch = (holidayId, token) => async (dispatch) => {
  try {
    dispatch(getProjectHolidayRequest());
    const { data } = await axiosInstance.get('/ProjectHoliday/GetProjectHolidayById', {
      ...getAxiosConfig(token),
      params: { HolidayId: holidayId },
    });
    dispatch(getProjectHolidayByIdSuccess());
    return data;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch(getProjectHolidayFail(message));
    return { status: 0, message };
  }
};

const saveProjectHoliday = (url, payload, token, successText) => async (dispatch) => {
  try {
    dispatch(saveProjectHolidayRequest());
    const { data } = await axiosInstance.post(url, payload, getAxiosConfig(token));
    if (data?.status === 1) dispatch(saveProjectHolidaySuccess(data.message || successText));
    else dispatch(saveProjectHolidayFail(data?.message || 'Unable to save holiday'));
    return data;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch(saveProjectHolidayFail(message));
    return { status: 0, message };
  }
};

export const createProjectHolidayDispatch = (payload, token) =>
  saveProjectHoliday('/ProjectHoliday/CreateProjectHoliday', payload, token, 'Holiday created successfully');

export const updateProjectHolidayDispatch = (payload, token) =>
  saveProjectHoliday('/ProjectHoliday/UpdateProjectHoliday', payload, token, 'Holiday updated successfully');

export const createProjectHolidayBulkDispatch = (payload, token) =>
  saveProjectHoliday('/ProjectHoliday/CreateProjectHolidayBulk', payload, token, 'Holidays created successfully');

export default ProjectHolidayReducer;
